import { useQuery } from '@tanstack/react-query';
import { fileService } from '../services/fileService';
import type { FileQueryParams } from '../types';

export function useFiles(params: FileQueryParams = {}) {
  return useQuery({
    queryKey: ['files', params],
    queryFn: () => fileService.getFiles(params),
  });
}
